import { ICaseResolutionPlanStepModel } from '../../../../interfaces/ICaseResolutionModel';
import { IUserModel } from '../../../../interfaces/IUser';

interface CaseResolutionStepperProps {
    steps: ICaseResolutionPlanStepModel[];
    currentStep: ICaseResolutionPlanStepModel;
    stepKey: number;
    zoneUsers: IUserModel[];
}

export function CaseResolutionStepper({
    steps,
    stepKey,
    zoneUsers,
}: CaseResolutionStepperProps) {
    const getUser = (userId: string, index: number) => {
        const user = zoneUsers.find((x) => x.guid === userId);
        if (user) {
            return user.profile?.firstName + ' ' + user.profile?.lastName;
        }
        return undefined;
    };

    return (
        <div className="stepper-container">
            {steps.map((step, index) => {
                const stepNumber = index;
                const isActive = stepNumber === stepKey;
                const isCompleted = stepNumber < stepKey;

                return (
                    <div key={stepNumber} className={`step-item ${isCompleted ? 'completed' : ''}`}>
                        <div
                            className={`step-circle ${isCompleted ? 'completed' : ''} ${isActive ? 'active' : ''}`}
                        >
                            <span>{stepNumber + 1}</span>
                        </div>

                        <div className="ms-3 step-label">
                            {step.name}
                            <br></br>
                            <div style={{ fontSize: 10 }}>
                                {steps[index].userId
                                    ? ' - ' + getUser(steps[index].userId, index)
                                    : 'Not Assigned'}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
